
export const REMINDER_ROUTES = [
  {
    path: "serviceReminderForm",
    name: "serviceReminderForm",
    component: () =>
        import(/* webpackChunkName: "reminders" */ "@/modules/reminders/components/forms/ServiceReminderForm")
  },
  {
    path: "vehicleRenewalForm",
    name: "vehicleRenewalForm",
    component: () =>
        import(/* webpackChunkName: "reminders" */ "@/modules/reminders/components/forms/VehicleRenewalForm")
  },

  {
    path: "contactRenewalForm",
    name: "contactRenewalForm",
    component: () =>
        import(/* webpackChunkName: "reminders" */ "@/modules/reminders/components/forms/ContactRenewalForm")
  }
];
